<template>
    <div :style="`display: flex; ${isSent ? 'justify-content: flex-end;' : 'justify-content: flex-start;'}`">
        <!-- Received side logo -->
        <div v-if="!isSent" style="display: flex; align-items: flex-start; padding-top: 20px;">
            <img :src="isSystem ? require('../../../../assets/img/chat/images/notice.png') : logo" style="width: 35px; height: 35px;" />
        </div>
        <!-- Bubble contents -->
        <div :class="isSent ? 'bubble bubble-sent' : 'bubble bubble-received'">
            <!-- Text Message -->
            <div v-if="type == 0" style="word-break: break-word;">
                <p v-html="processMsg(message)"></p>
            </div>

            <!-- Image Message -->
            <div v-else-if="type == 1">
                <img :src="message" style="max-width: 100%; max-height: 100%; cursor: pointer;"
                    @click="openImagePreview = true" />
            </div>

            <!-- Video Message -->
            <div v-else-if="type == 8"
                style="background-color: black; width: 100%; display: flex; justify-content: center; align-items: center; padding: 45px;">
                <img src="../../../../assets/img/chat/images/video.png"
                    style="width: 45px; height: 45px; cursor: pointer;" @click="openVideoPreview = true" />
            </div>

            <!-- File Message -->
            <div v-else-if="type == 3" style="width: 100%; display: flex;">
                <img :src="chooseFileType(message)" style="width: 45px; height: 45px; cursor: pointer;" @click="downloadFile(message)" />
            </div>

            <div class="msg-time">
                {{ getTime(time) }}
            </div>
        </div>
        <!-- Sent side logo -->
        <div v-if="isSent" style="display: flex; align-items: flex-end; padding-bottom: 20px;">
            <img :src="logo" style="width: 35px; height: 35px;" />
        </div>

        <!-- Image preview -->
        <el-dialog :visible.sync="openImagePreview" width="fit-content" :before-close="closeImagePreview" append-to-body>
            <img :src="message" style="height: 60vh; width: auto; max-width: 80vw; padding-bottom: 20px;" />
        </el-dialog>

        <!-- Video preview -->
        <el-dialog :visible.sync="openVideoPreview" width="fit-content" :before-close="closeVideoPreview" append-to-body>
            <video controls style="height: 60vh; width: auto; max-width: 80vw; padding-bottom: 20px;">
                <source :src="message" >
            </video>
        </el-dialog>
    </div>
</template>

<script>
import { EMOJI_ICONS } from "../../../../assets/img/chat/images/emoji/emoji.js"
export default {
    name: "ChatBubble",
    props: {
        type: {
            type: Number,
            default: 0
        },
        message: {
            type: String,
            required: true
        },
        isSent: {
            type: Boolean,
            default: false
        },
        time: {
            type: Number,
            default: 0
        },
        isSystem: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            logo: localStorage.getItem("chatLogo"),
            openImagePreview: false,
            openVideoPreview: false,
            emojiList: EMOJI_ICONS,
        }
    },
    methods: {
        chooseFileType(filename) {
            if (typeof filename !== '') {
                var type = this.getExt(filename);
            }

            var path = require("../../../../assets/img/chat/images/chat_files/def.png")

            if (type == "doc") {
                path = require('../../../../assets/img/chat/images/chat_files/doc.png');
            } else if (type == "docx") {
                path = require('../../../../assets/img/chat/images/chat_files/doc.png');
            } else if (type == "pdf") {
                path = require('../../../../assets/img/chat/images/chat_files/pdf.png');
            } else if (type == "xls") {
                path = require('../../../../assets/img/chat/images/chat_files/xls.png');
            } else if (type == "xlsx") {
                path = require('../../../../assets/img/chat/images/chat_files/xls.png');
            } else if (type == "mp3") {
                path = require('../../../../assets/img/chat/images/chat_files/mp3.png');
            } else if (type == "txt") {
                path = require('../../../../assets/img/chat/images/chat_files/txt.png');
            } else if (type == "zip") {
                path = require('../../../../assets/img/chat/images/chat_files/zip.png');
            } else if (type == "png") {
                path = require('../../../../assets/img/chat/images/chat_files/png.png');
            } else if (type == "rar") {
                path = require('../../../../assets/img/chat/images/chat_files/rar.png');
            } else if (type == "def") {
                path = require('../../../../assets/img/chat/images/chat_files/def.png');
            } else if (type == "jpeg") {
                path = require('../../../../assets/img/chat/images/chat_files/jpeg.png');
            } else if (type == "jpg") {
                path = require('../../../../assets/img/chat/images/chat_files/jpeg.png');
            } else if (type == "gif") {
                path = require('../../../../assets/img/chat/images/chat_files/gif.png');
            } else if (type == "html") {
                path = require('../../../../assets/img/chat/images/chat_files/html.png');
            } else if (type == "ppt") {
                path = require('../../../../assets/img/chat/images/chat_files/ppt.png');
            } else if (type == "pptx") {
                path = require('../../../../assets/img/chat/images/chat_files/ppt.png');
            } else if (type == "odp") {
                path = require('../../../../assets/img/chat/images/chat_files/ppt.png');
            }

            return path;
        },
        getExt(filename) {
            if (filename) {
                var ext = filename.split('.').pop();
                if (ext == filename) return "";
                return ext;
            }
        },
        downloadFile(link) {
            window.open(link);
        },
        getTime(timestamp) {
            return this.$moment(timestamp).format("YYYY-MM-DD HH:mm");
        },
        processMsg(message) {
            let that = this;
            for (var index in this.emojiList) {
                var tempEmoji = this.emojiList[index];
                var ref = "face[" + this.emojiList[index] + "]";

                let joiningEmoji = ''

                switch (tempEmoji) {
                    case '亲亲':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/f341519602044f3b8c9f4158e0fd2fec亲亲.png" style="width: 20px; height: auto;" />';
                        break;
                    case '偷笑':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/9f65ccef8c244f5dae3f565b921bc4e4偷笑.png" style="width: 20px; height: auto;" />';
                        break;
                    case '可怜':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/52a232b0c36d414fb0ac0b8dbe2e7005可怜.png" style="width: 20px; height: auto;" />';
                        break;
                    case '可爱':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/fab576f4341d4146960b31aadff19934可爱.png" style="width: 20px; height: auto;" />';
                        break;
                    case '吃惊':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/0eb561d3d3304812abb82e306c6a446f吃惊.png" style="width: 20px; height: auto;" />';
                        break;
                    case '哈哈':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/d13ebb37ba474e05b128cdff1e364f34哈哈.png" style="width: 20px; height: auto;" />';
                        break;
                    case '委屈':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/44cbadb33c3b49d5a17daf9e6eb8e99b委屈.png" style="width: 20px; height: auto;" />';
                        break;
                    case '害羞':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/85d7ce737dc744628ef97a19983e6352害羞.png" style="width: 20px; height: auto;" />';
                        break;
                    case '微笑':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/065c16d86e75415ba9cce5ffbc996ef5微笑.png" style="width: 20px; height: auto;" />';
                        break;
                    case '悲伤':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/8f1a6b2eb7d244aba44f1f0a27fe25f0悲伤.png" style="width: 20px; height: auto;" />';
                        break;
                    case '拜拜':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/125042f5f0db4638b481f8f71017ecae拜拜.png" style="width: 20px; height: auto;" />';
                        break;
                    case '挖鼻':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/b154d6abfc8d48128df8cbaaf3d4096f挖鼻.png" style="width: 20px; height: auto;" />';
                        break;
                    case '爱你':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/70c63c900d454c68b7dbc2895e5722da爱你.png" style="width: 20px; height: auto;" />';
                        break;
                    case '生病':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/426d2de0604743e3bc15d016777ad88d生病.png" style="width: 20px; height: auto;" />';
                        break;
                    case '鄙视':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/7d884b0bffeb4014843a236c1ced3f99鄙视.png" style="width: 20px; height: auto;" />';
                        break;
                    case '闭嘴':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/4d9bddd4a8ce42ea883610c2e59341d5闭嘴.png" style="width: 20px; height: auto;" />';
                        break;
                    case '馋嘴':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/6c647583f01e490fa44da41f9c7f6a9d馋嘴.png" style="width: 20px; height: auto;" />';
                        break;
                    case '黑线':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/8ccbc3efbe2e46758a3aeb6818c1e75d黑线.png" style="width: 20px; height: auto;" />';
                        break;
                    case '鼓掌':
                        joiningEmoji =
                            '<img src="https://idcard0.oss-ap-southeast-1.aliyuncs.com/2023-08-03/8259ecd4bd624b94afa61eb113a7ffdf鼓掌.png" style="width: 20px; height: auto;" />';
                        break;
                    default:
                        joiningEmoji = ''
                        break;
                }

                message = message.split(ref).join(joiningEmoji);
            }

            return message;
        },
        closeImagePreview() {
            this.openImagePreview = false;
        },
        closeVideoPreview() {
            this.openVideoPreview = false;
        }
    }
}
</script>

<style scoped>
.bubble {
    background-color: #dcdee0;
    padding: 10px;
    border-radius: 15px;
    margin: 20px;
    max-width: 70%;
    font-size: 14px;
    position: relative;
}

.bubble-received::before {
    content: "";
    position: absolute;
    left: -17px;
    transform: translateY(-50%);
    border-width: 11px 25px 5px 0;
    border-style: solid;
    border-color: transparent #dcdee0 transparent transparent;
}

.bubble-sent::after {
    content: "";
    position: absolute;
    right: -17px;
    transform: translateY(-50%);
    border-width: 11px 0 5px 25px;
    /* Top, right, bottom, left border width */
    border-style: solid;
    border-color: transparent transparent transparent #dcdee0;
}

.msg-time {
    float: right;
    color: #646566;
    font-size: 10px;
    text-align: right;
    padding-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/module/chat/components/chatBubble.vue